export default __webpack_public_path__ + "static/media/ies_conferencistas.008e7814.png";